import { DeepReadonly, TagType } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const nonRemovableTagTypes: DeepReadonly<Array<TagType>> = deepFreeze([
  TagType.OVER_12_MONTHS_UK,
  TagType.UNDER_12_MONTHS_UK,
  TagType.PATHWAY,
  TagType.EUSS_GRANTED,
  TagType.EUSS_PENDING,
  TagType.MULTI_INTAKE,
  TagType.MANUAL_CAS
]);
